"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _react = require("@emotion/react");

var mainButton = function mainButton(theme) {
  return /*#__PURE__*/(0, _react.css)("border-top-right-radius:0;border-bottom-right-radius:0;padding-right:", theme.spacing[5], ";&:hover{position:relative;z-index:1;}" + (process.env.NODE_ENV === "production" ? "" : ";label:mainButton;"));
};

var dropdownBtn = function dropdownBtn(theme) {
  return /*#__PURE__*/(0, _react.css)("border-radius:0 ", theme.spacing[3], " ", theme.spacing[3], " 0;margin-left:-1px;&>svg{transform:rotate(90deg);}" + (process.env.NODE_ENV === "production" ? "" : ";label:dropdownBtn;"));
};

var noBorder = function noBorder(theme) {
  return /*#__PURE__*/(0, _react.css)("border-left:1px solid rgba(", theme.color.monochrome.white_rgba, ", 0.25)!important;" + (process.env.NODE_ENV === "production" ? "" : ";label:noBorder;"));
};

var mainButtonWithoutBorder = function mainButtonWithoutBorder(theme) {
  return /*#__PURE__*/(0, _react.css)("border-right:1px solid rgba(", theme.color.monochrome.white_rgba, ", 0.25)!important;" + (process.env.NODE_ENV === "production" ? "" : ";label:mainButtonWithoutBorder;"));
};

var styles = {
  mainButton: mainButton,
  dropdownBtn: dropdownBtn,
  noBorder: noBorder,
  mainButtonWithoutBorder: mainButtonWithoutBorder
};
exports.styles = styles;
//# sourceMappingURL=DropdownWithButton.styles.js.map